/**
 * <s-reveal>
 * Sets `data-visible` on itself the first time it scrolls into view, so CSS can
 * play an entrance animation once. Without IntersectionObserver it reveals at once.
 */
class Reveal extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (!('IntersectionObserver' in window)) {
      this.setAttribute('data-visible', '');
      return;
    }
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.setAttribute('data-visible', '');
          this.#observer?.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-reveal')) {
  customElements.define('s-reveal', Reveal);
}
